import React, { useState, useEffect } from 'react'
import { Form, Formik } from 'formik'
import * as yup from 'yup'
import PropTypes from 'prop-types'
import DialogWithCloseIcon from '../../DialogWithCloseIcon/DialogWithCloseIcon'
import MyTextField from '../../form/fields/MyTextField'
import ImageCrop from '../ImageCropComponents/ImageCrop/ImageCrop'
import ButtonWithLoader from '../ButtonWithLoader/ButtonWithLoader'
import { Typography } from '@material-ui/core'

const AddClubModal = ({ isOpen, onClose, createClub, updateClub, clubData }) => {
  const isEditMode = Boolean(clubData)
  const initialLogoUrl = clubData?.logoUrl || ''
  const [croppedLogo, setCroppedLogo] = useState(initialLogoUrl)

  useEffect(() => {
    setCroppedLogo(clubData?.logoUrl || '')
  }, [clubData?.id])

  const getLogoDataUri = () => {
    if (croppedLogo === initialLogoUrl) return null
    return croppedLogo || ''
  }

  const handleSubmit = (values) => {
    if (isEditMode) {
      updateClub.mutate({
        clubId: clubData.id,
        name: values.name,
        logoDataUri: getLogoDataUri(),
      })
    } else {
      createClub.mutate({
        name: values.name,
        logoDataUri: getLogoDataUri(),
      })
    }
  }

  return (
    <DialogWithCloseIcon
      open={isOpen}
      onClose={onClose}
      dialogWidth='500px'
      dialogTitle={
        <Typography variant='h6' style={{ fontWeight: 'bold' }}>
          {isEditMode ? 'Edit Club' : 'Add Club'}
        </Typography>
      }
    >
      <Formik
        initialValues={{ name: clubData?.name || '' }}
        validationSchema={yup.object().shape({
          name: yup.string().required(),
        })}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {() => (
          <Form>
            <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ImageCrop
                  key={clubData?.id || 'new'}
                  defaultImageSrc={initialLogoUrl}
                  setCroppedImage={setCroppedLogo}
                  width={200}
                  height={200}
                  addImageLabel='Upload Logo'
                />
              </div>
              <MyTextField name='name' label='Club Name' required />
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ButtonWithLoader
                  label={isEditMode ? 'Save' : 'Add'}
                  loading={isEditMode ? updateClub?.isLoading : createClub?.isLoading}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </DialogWithCloseIcon>
  )
}

AddClubModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  createClub: PropTypes.object,
  updateClub: PropTypes.object,
  clubData: PropTypes.object,
}

export default AddClubModal
